import getUserConfiguration from 'owa-session-store/lib/actions/getUserConfiguration';
import ReactListViewType from 'owa-service/lib/contract/ReactListViewType';
import { parseUrlSearchParams } from 'mini-common-utils/lib/utils/parseUrlSearchParams';

/**
 * Returns the listView type from userConfig.
 * If it's null, returns ReactListViewType.Conversation.
 */
export function getListViewType() {
    const overriddenViewSettings = getViewOverride();
    if (overriddenViewSettings !== null) {
        return overriddenViewSettings;
    }

    const listViewType =
        getUserConfiguration().UserOptions.GlobalListViewTypeReact ||
        ReactListViewType.Conversation;
    return listViewType;
}

/**
 * Uses window.location.search to check whether a view override has been provided.
 * This queryParam is only supposed to be used from automation tests, to force a view.
 */
const getViewOverride = () => {
    const searchParams = parseUrlSearchParams(window.location.search);
    switch (searchParams?.listViewType) {
        case 'item':
            return ReactListViewType.Message;
        case 'conversation':
            return ReactListViewType.Conversation;
        default:
            return null;
    }
};
